import {createContext, useContext, useState} from "react";

interface Props {
    children: React.ReactNode;
}

const MainNavStickyContext = createContext<{
    mainNavSticky: boolean;
    setMainNavSticky: (val: boolean) => void;
}>({
    mainNavSticky: true,
    setMainNavSticky: () => {},
});

export const MainNavStickyProvider = ({ children }: Props) => {
    const [mainNavSticky, setMainNavSticky] = useState(true);

    return (
        <MainNavStickyContext.Provider value={{ mainNavSticky, setMainNavSticky }}>
            {children}
        </MainNavStickyContext.Provider>
    );
}

export const useMainStickyNav = () => useContext(MainNavStickyContext);